import React, { useState } from 'react';
import './Section_7.css';


function Section7({ sectionConfig }) {
  if (!sectionConfig || !sectionConfig.faqs) return null;

  return (
    <section className="section-7">
      <h2 className="section-7-title">{sectionConfig.title}</h2>

      <div className="faq-list">
        {sectionConfig.faqs.map((faq, idx) => (
          <FAQItem key={idx} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </section>
  );
}

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        {question}
      </div>
      {isOpen && <div className="faq-answer">{answer}</div>}
    </div>
  );
}

export default Section7;